import EtaCalculada from "./EtaCalculada";
export default EtaCalculada;